import numeral from 'numeral';

export const useFormatNumber = () => {
  const numberDecimal = (value: number | undefined) => {
    return numeral(value ?? 0).format('0,0.00');
  };
  const numberAbs = (value: number | undefined) => {
    return numeral(value ?? 0).format('0,0');
  };

  const numberToFix = (value: number | undefined, length = 2) => {
    const numberLength = new Array(length).fill('0').join('');
    return numeral(value ?? 0).format(`0.${numberLength}`);
  };

  const formatPercents = (value: number) => {
    return numeral(value).format('0[.]00%');
  };

  return { numberDecimal, numberAbs, numberToFix, formatPercents };
};
